import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import "./terms.css";

const sectionKeys = [
  "service", "eligibility", "account", "data", "use", "availability", "intellectualProperty",
  "privacy", "disclaimer", "liability", "termination", "changes", "contact",
] as const;

export const TermsPage = () => {
  const { t } = useTranslation("terms");

  return (
    <main className="app-page py-8 sm:py-12">
      <div className="app-container max-w-4xl">
        <header className="mb-8 flex items-center justify-between gap-4 sm:mb-12">
          <Link to="/" className="inline-flex min-h-11 items-center text-sm font-semibold text-[var(--app-text)] underline underline-offset-4 hover:text-[var(--app-text-secondary)]">{t("terms.home")}</Link>
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--app-text)]">
            <img src="/brand/jerry-j-mark-ink.svg" alt="HeyJerry!" className="terms-brand-mark terms-brand-mark--light" />
            <img src="/brand/jerry-j-mark-crema.svg" alt="HeyJerry!" className="terms-brand-mark terms-brand-mark--dark" />
            Hey Jerry
          </span>
        </header>
        <article className="app-panel-raised p-6 sm:p-10" aria-labelledby="terms-title">
          <p className="text-[length:var(--ds-type-overline-size)] font-medium uppercase tracking-[var(--ds-type-overline-tracking)] text-[var(--app-text-secondary)]">Hey Jerry</p>
          <h1 id="terms-title" className="mt-4 font-[var(--ds-font-display)] text-[length:var(--ds-type-title-size)] font-medium leading-[var(--ds-type-title-line)] tracking-[var(--ds-type-title-tracking)] text-[var(--app-text)]">{t("terms.title")}</h1>
          <p className="mt-4 text-sm text-[var(--app-text-secondary)]">{t("terms.updated")}</p>
          <p className="mt-8 max-w-2xl text-base leading-6 text-[var(--app-text-secondary)]">{t("terms.intro")}</p>
          <div className="mt-10 space-y-8">
            {sectionKeys.map((key) => (
              <section key={key} aria-labelledby={`terms-${key}`}>
                <h2 id={`terms-${key}`} className="font-[var(--ds-font-sans)] text-[length:var(--ds-type-heading-size)] font-medium leading-[var(--ds-type-heading-line)] tracking-[var(--ds-type-heading-tracking)] text-[var(--app-text)]">{t(`terms.sections.${key}.title`)}</h2>
                <p className="mt-3 max-w-3xl text-base leading-6 text-[var(--app-text-secondary)]">{t(`terms.sections.${key}.body`)}</p>
              </section>
            ))}
          </div>
        </article>
      </div>
    </main>
  );
};
